import Dexie, { PromiseExtended, Table } from 'dexie';

type CsvRow = Record<string, string>;
export type Dataset = { id: string; name: string; rows: CsvRow[]; createdAt: string };
type CompositionField = {
  name: string;
  nameIsConstant: boolean;
  concentration: string;
  concentrationIsConstant: boolean;
};
export type Liquidset = {
  id: string;
  plate: string;
  name: string;
  table: string;
  liquidName: string;
  plateName: string;
  well: string;
  composition: CompositionField[];
};

export type Plate = {
  id: string;
  description: string;
  rows: number;
  columns: number;
  maxVolume: number;
};

type DataStore = {
  addDataset: (ds: Dataset) => Promise<string>;
  getDataset: (id: string) => Promise<Dataset | undefined>;
  deleteDataset: (id: string) => Promise<number>;
  getDatasets: () => Promise<Dataset[]>;
  addLiquidset: (ls: Liquidset) => Promise<string>;
  getLiquidset: (id: string) => Promise<Liquidset | undefined>;
  deleteLiquidset: (id: string) => Promise<number>;
  getLiquidsets: () => Promise<Liquidset[]>;
  getPlates: () => Promise<Plate[]>;
  clearPlates: () => Promise<void>;
  addPlates: (plates: Plate[]) => PromiseExtended<string>;
};

class DiscoPrototypeDB extends Dexie {
  datasets!: Table<Dataset, string>;
  liquidsets!: Table<Liquidset, string>;
  plates!: Table<Plate, string>;

  constructor() {
    super('discoPrototypeDB');

    this.version(1).stores({
      datasets: '&id, name',
      liquidsets: '&id, name',
    });

    this.version(2).stores({
      datasets: '&id, name',
      liquidsets: '&id, name',
      plates: '&id',
    });
  }
}

const db = new DiscoPrototypeDB();

export const discoPrototypeStore: DataStore = {
  addDataset: ds => db.datasets.add(ds),
  deleteDataset: id => db.datasets.where('id').equals(id).delete(),
  getDataset: id => db.datasets.get(id),
  getDatasets: () => db.datasets.toArray(),
  addLiquidset: ls => db.liquidsets.add(ls),
  deleteLiquidset: id => db.liquidsets.where('id').equals(id).delete(),
  getLiquidset: id => db.liquidsets.get(id),
  getLiquidsets: () => db.liquidsets.toArray(),
  getPlates: () => db.plates.toArray(),
  clearPlates: () => db.plates.clear(),
  addPlates: (plates: Plate[]) => db.plates.bulkAdd(plates),
};
